import { combineReducers, configureStore } from "@reduxjs/toolkit";
import authSlice from "./slices/auth.Slice";
import searchSlice from "./slices/search.slice";
import playerSlice from "./slices/player.slice";
import showcaseSlice from "./slices/showcase.slice";
import subscriptionSlice from "./slices/subscription.slice";
import networkSlice from "./slices/network.slice";

// Custom middleware to save auth state to cookies
const cookieMiddleware = (store) => (next) => (action) => {
  const result = next(action);

  // Save auth state to cookies after each auth action
  if (action.type?.startsWith('auth/') && typeof window !== "undefined") {
    setTimeout(() => {
      const state = store.getState();
      const authState = state.Auth;

      try {
        const domain = process.env.DEPLOY_URL || "localhost";
        const profileHasData = authState?.profile && Object.keys(authState.profile).length > 0;
        const hasAuthData = Boolean(authState?.isLogin || authState?.userToken || profileHasData);

        if (!hasAuthData) {
          const expired = new Date(0).toUTCString();
          document.cookie = `persist:auth=; expires=${expired}; domain=${domain}; path=/`;
          document.cookie = `persist:auth=; expires=${expired}; path=/`;
          return;
        }

        const cookieData = {
          user: authState.profile ? JSON.stringify(authState.profile) : null,
          token: authState.userToken ? JSON.stringify(authState.userToken) : null,
          isAuthenticated: JSON.stringify(authState.isLogin || false)
        };

        const today = new Date();
        const expires = new Date(today.setFullYear(today.getFullYear() + 1));
        document.cookie = `persist:auth=${encodeURIComponent(JSON.stringify(cookieData))}; expires=${expires.toUTCString()}; domain=${domain}; path=/`;
      } catch (error) {
        console.warn("Failed to save auth state to cookies:", error);
      }
    }, 0);
  }

  return result;
};

const rootReducer = combineReducers({
  Auth: authSlice,
  Search: searchSlice,
  Player: playerSlice,
  Showcase: showcaseSlice,
  Subscription: subscriptionSlice,
  Network: networkSlice,
});

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['auth/restoreState'],
      },
    }).concat(cookieMiddleware),
  devTools: true,
});
